import "./index.less";
import util from "./_util/util";
// import "./weaJs";

const req = require.context(
  "./ecology9",
  true,
  /^\.\/[^_][\w-]+\/(style\/)?index\.js?$/
);
const base = require.context(
  "./ecology9/base",
  true,
  /^\.\/[^_][\w-]+\/(style\/)?index\.js?$/
);

req.keys().forEach(mod => {
  const v = req(mod);
  const match = mod.match(/^\.\/([^_][\w-]+)\/index\.js?$/);
  if (match && match[1]) {
    try {
      // console.log(v.default);
      const name = util.camelCase(match[1]);
      // v.default = util.tryCatch(React, MyErrorHandler, {error: "前端组件库异常，请联系管理员!"})(v.default);
      exports[name] = v.default;
    } catch (e) {
      console.log(e);
    }
  }
});

base.keys().forEach(mod => {
  const v = base(mod);
  const match = mod.match(/^\.\/([^_][\w-]+)\/index\.jsx?$/);
  if (match && match[1]) {
    try {
      const name = util.camelCase(match[1]);
      exports["Base" + name] = v.default;
    } catch (e) {
      console.log(e);
    }
  }
});



// WEBPACK FOOTER //
// ./_ecCom.js